<template>
  <div class="typo-h5">
    {{ label }}:
  </div>
  <PrmSkeleton
    v-if="isLoading"
  />
  <div
    v-else
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  label: string,
  isLoading: boolean,
}>();
</script>
